<template>
  <div class="wrap">
    <!-- 头部 -->
    <headTop :toggle="0"></headTop>
    <!-- 中间内容 -->
    <div class="specialistContent">
        <div >
            <div class="contentTitle" >
        <div class="line"></div>
        <img src="@/assets/image/aboutUs/aboutUsBc.png" alt />
        <div class="titleBcImg">
          <span style="margin-bottom:0.2em">{{mode.name}}</span>
          <span class="eng" @click="goToEnterPrise(mode.enterpriseId)">{{mode.officeNameStr}}</span>
        </div>
        <div class="line"></div>
      </div>
      <div class="content" style="padding:0em 3em">
        <img :src="$store.getters.imgUrl+mode.avatar" alt v-if="mode.avatar" />
        <img src="@/assets/image/specialistCenter/headPortrait.png" alt v-else />
        <div class="contentRight">
            <h4>个人介绍</h4>
            <div v-html="mode.introduceContent"></div>
        </div>
      </div>
        </div>
      
      <div class="footer">
        <footCode></footCode>
      </div>

          <div class="zixun-wrapper">
          <div class="zixun-top">
             <img src="@/assets/image/index/gif-1.gif" alt />
          </div>
          <div class="zixun-bottom">
            
        <div class="zixun" @click="goToConsultation()">
          <img src="@/assets/image/index/1.png" alt />
          <span>在线咨询</span>
        </div>
          </div>

        </div>
    </div>
  </div>
</template>
<script>
import footCode from "../../components/footCode";
import headTop from "../../components/HeadTop";
export default {
  name: "detail",
  components: {
    footCode,
    headTop,
  },

  data() {
    return {
      id: "",
      mode: {},
      lineIndex: null,
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getInfo();
  },
  methods: {
    getInfo() {
      this.ajaxUtil({
        method: "get",
        url:
          this.$store.state.axiosUrl +
          `/api/home/getExpertInfoById?expertId=${this.id}`,
      }).then((res) => {
        this.mode = res.data;
        // console.log(this.mode)
        console.log(this.mode);
      });
    },
    // goToEnterPrise(id) {
    //   this.$router.push({
    //     path: "/enterprise/enterpriseDetail",
    //     query: { id },
    //   });
    // },
     goToConsultation(pid) {
      if (!pid) pid = 0;
      let token = sessionStorage.getItem("token");
      if (!token) {
        this.$message.error("请先登录");
        return false;
      } else {
        this.$store.commit("changechatShow", true);
        this.$store.commit("changePid", pid);
      }
    },
  },
};
</script>
<style scoped lang="less">
.wrap {
  display: flex;
  flex-direction: column;
  min-width: 12.8em;
  .specialistContent {
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: space-between;
    // overflow: auto;
    background: #e9f0f6;
    .titlePosition {
      font-size: 0.15em;
      display: flex;
      justify-content: flex-end;
      width: 100%;
      color: #666;
    }
    .contentTitle {
      margin-top: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      img {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
      }
      .titleBcImg {
        height: 78px;
        // width: 113px;
        background-size: cover;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 0.22em;
        position: relative;
        margin-top: 1em;
        white-space: nowrap;
        .eng {
          text-align: center;
          width: 249px;
          height: 18px;
          font-size: 15px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #2579bf;
          bottom: 0;

          cursor: pointer;
        }
      }
      .line {
        width: 250px;
        height: 1px;
        background-color: #999;
      }
    }

    .content {
      display: flex;
      width: 100%;
      margin-top: 20px;
      img{
          height: 2em;
          width: 1.8em;
      }
      .contentRight{
          margin-left: 30px;
          display: flex;
          flex-direction: column;
          height: 100%;
           h4{
          font-size: 0.2em;
      }
      div{
          margin-top: 10px;
           font-size: 0.18em;
           text-indent: 2em;
      }
      }
     
    }
  }
}
.buttonFont {
  font-size: 1.625em;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  letter-spacing: 0.3125em;
  color: #ffffff;
}
.buttonCloumn {
  text-align: center;
  margin-top: 60px;
  margin-bottom: 90px;
}
// 咨询
.zixun-wrapper{
    position: fixed;
    top: 1.3em;
    right: 0;
  //   	animation: myFrame1 2s linear infinite;
	// -webkit-animation: myFrame1 2s linear infinite;
    // border-radius: 50%;
     border-radius: 5px 0px 0px 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .zixun-top{
    height: 150px;
    margin-bottom:10px;
  }
  .zixun-bottom{
    width: 140px;
  }
  .zixun {
    background: #2579BF;
    border-radius: 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    padding: 0.1em 0.10em 0.1em 0.10em;
    width: 1.4em;
    height: 0.4em;
    margin-right: 0.58em;
    cursor: pointer;
    img {
      height: 0.2em;
      width: 0.25em;
    }
    span {
      font-size: 0.2em;
      text-align: center;
      color: #fff;
      margin-left:8px ;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/savant/detail.vue